import { render } from "./Disbursment.vue?vue&type=template&id=23b5432f&scoped=true"
import script from "./Disbursment.vue?vue&type=script&lang=js"
export * from "./Disbursment.vue?vue&type=script&lang=js"

import "./Disbursment.vue?vue&type=style&index=0&id=23b5432f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b5432f"]])

export default __exports__